import { all } from "redux-saga/effects";
import { discoverySagas } from "../../pages/discovery";
import { dashboardSagas } from "../../pages/orderPage";
import { cartSagas } from "../../pages/cart";

export default function* rootSaga() {
    yield all([discoverySagas(), dashboardSagas(), cartSagas()]);
}
